import React, { useState } from "react";
import propTypes from "prop-types";
import { getStorageData, setStorageData } from "utils/helper";
import AccordionComponents from "components/FormsComponents/AccordionComponets";
import TextBoxComponent from "components/FormsComponents/TextBoxComponent";
import ButtonComponent from "components/FormsComponents/ButtonComponent";
import CheckBoxComponent from "components/FormsComponents/CheckBoxComponent";
import { DOMAIN_CLINKS, DOMAIN_MTC } from "constants/app";
import { filterField } from "./constants";
import { FaArrowDown, FaSearch, FaUndo } from "react-icons/fa";
import TooltipTextComponent from "components/FormsComponents/TooltipTextComponent";
import { FaCESvgIcn } from "svgIcon";

const LeftSideFilterComponent = ({
  formData,
  setFormData,
  filterData,
  setFilterData,
  filterAllData,
  isMobileView,
  setIsMobileView,
}) => {
  const setDataStorage = (data = "") => {
    setStorageData("user_data", data ? data : formData);
  };
  const domain = getStorageData("domain");
  const [allExpand, setAllExpand] = useState(false);
  const localAuthorityOption = getStorageData("local_authority");
  const [showFieldLeft, setShowFieldLeft] = useState(
    filterField(domain, allExpand).filter((item) => item.isShow === true),
  );
  const [searchText, setSearchText] = useState(formData?.name);
  const onSearchKeyWord = () => {
    setFormData({
      ...formData,
      name: searchText,
    });
  };

  const handleCheckBox = ({ target: { name, value, checked } }) => {
    const parsedValue = parseInt(value);
    if (parsedValue) {
      let newValue;
      if (checked) {
        newValue = formData?.[name]?.length
          ? [...formData[name], parsedValue]
          : [parsedValue];
      } else {
        newValue = formData?.[name]?.filter((item) => item !== parsedValue);
      }
      if (name === "county" && !checked) {
        let county_data = localAuthorityOption?.[value];
        let newLocalAuthority = formData?.local_authority
          ? formData.local_authority
          : [];

        if (county_data?.length) {
          county_data.map((item) => {
            if (newLocalAuthority.includes(item.value)) {
              newLocalAuthority = newLocalAuthority.filter(
                (items) => item.value !== items,
              );
            }
          });
        }
        setFormData({
          ...formData,
          [name]: newValue,
          local_authority: newLocalAuthority,
        });
      } else {
        setFormData({
          ...formData,
          [name]: newValue,
        });
      }
    }
  };

  const filterSearch = ({ target: { name, value } }) => {
    if (value.length >= 3) {
      let newData = filterData?.[name].filter((item) =>
        item.label.toLowerCase().includes(value.toLowerCase()),
      );
      setFilterData({
        ...filterData,
        [name]: newData,
      });
    } else {
      setFilterData({
        ...filterData,
        [name]: filterAllData[name],
      });
    }
  };

  const clearAllFilter = (name) => {
    let name_value = name?.length ? name[0] : name;
    if (name_value === "county") {
      setFormData({
        ...formData,
        [name]: [],
        local_authority: [],
      });
      setDataStorage({
        ...formData,
        [name]: [],
        local_authority: [],
      });
    } else {
      setFormData({
        ...formData,
        [name]: [],
      });
      setDataStorage({
        ...formData,
        [name]: [],
      });
    }
  };
  const handleResetFilter = () => {
    setFormData({
      pathway: [],
      pathway_name: [],
      sub_pathway: [],
      sub_pathway_name: [],
      keyword: [],
      keyword_name: [],
      county: [],
      county_name: [],
      name: "",
      is_clinks: formData.is_clinks,
    });
    setSearchText("");
  };

  const handleResetNameFilter = () => {
    setFormData({
      ...formData,
      name: "",
    });
    setSearchText("");
  };

  //Single toggle handler — updates both states together
  const handleExpandCollapse = () => {
    const nextExpand = !allExpand;
    setAllExpand(nextExpand);
    setShowFieldLeft(
      filterField(domain, nextExpand).filter((item) => item.isShow === true),
    );
  };

  const isClearFilterStatus =
    formData?.pathway?.length ||
    formData?.sub_pathway?.length ||
    formData?.keyword?.length ||
    formData?.county?.length ||
    formData?.target_group?.length ||
    formData?.probation_regions?.length ||
    formData?.regions?.length ||
    formData?.area_covered?.length ||
    formData?.prisons?.length ||
    formData?.custody_or_community?.length ||
    formData?.racially_minoritised?.length ||
    formData?.type_of_organisation?.length ||
    formData?.name
      ? true
      : false;

  return (
    <>
      <div className={`orgll__inner ${isMobileView ? "active" : ""}`}>
        {domain === DOMAIN_CLINKS ? (
          <div className="cust___search">
            <div className="mobf__title d-block d-lg-none">
              <div className="mobf__inner d-flex align-items-center justify-content-between gap-3">
                <p className="mb-0 me-1 opacity-75">Filter</p>
                <div className="d-flex align-items-center justify-content-end gap-4">
                  <div
                    class="text-white"
                    title="Apply & Close"
                    style={{ fontSize: "15px" }}
                    onClick={() => {
                      document.documentElement.classList.remove(
                        "filter_overlap",
                      );
                      setIsMobileView(false);
                    }}
                  >
                    Apply & Close
                  </div>
                </div>
              </div>
            </div>
            <div className="card__lbox bg-white">
              <div className="custs___inner d-flex flex-column gap-1 position-relative">
                <div className="custs___form d-flex align-items-center justify-content-between gap-2 position-relative">
                  <TextBoxComponent
                    name="name"
                    className="form-control-lg pe-4"
                    value={searchText}
                    title="Search by org name, pathway, sub-pathway, keyword, or description…"
                    handleInput={(e) => setSearchText(e.target.value)}
                    placeholder="Search here..."
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        onSearchKeyWord();
                      }
                    }}
                  />
                  {searchText &&
                  formData.name &&
                  formData.name === searchText ? (
                    <TooltipTextComponent
                      placement={"top"}
                      children={
                        <span
                          className="reset__search d-flex align-items-center justify-content-center rounded-pill"
                          onClick={handleResetNameFilter}
                          role="button"
                        >
                          <FaUndo style={{ width: 14, height: 14 }} />
                        </span>
                      }
                      tooltip_children={"Reset search"}
                    />
                  ) : (
                    <TooltipTextComponent
                      placement={"bottom"}
                      children={
                        <ButtonComponent
                          onClick={() => onSearchKeyWord()}
                          className="search__btn org__pop p-0 border-0"
                          isIcon={<FaSearch />}
                        />
                      }
                      tooltip_children={"Click to search"}
                    />
                  )}
                </div>
                {formData?.name && (
                  <h6 className="search__results mb-0">
                    <small className="fw-light opacity-75 me-1">
                      Results based on:
                    </small>
                    <small className="fw-normal">
                      {formData.name}
                      <TooltipTextComponent
                        placement={"top"}
                        children={
                          <span
                            className="ms-2 opacity-75"
                            onClick={handleResetNameFilter}
                            role="button"
                          >
                            <FaUndo
                              style={{
                                width: "12px",
                                height: "12px",
                                color: "rgb(var(--danger))",
                              }}
                            />
                          </span>
                        }
                        tooltip_children={"Reset search"}
                      />
                    </small>
                  </h6>
                )}
              </div>
            </div>
            <div className="cust___or d-flex align-items-center justify-content-center gap-2 py-2 position-relative">
              <small className="fw-300 opacity-75 text-uppercase">or</small>
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="card__lbox bg-white">
          <div className="cb__title d-flex align-items-center justify-content-between gap-3">
            <p className="mb-0">
              Refine your search by <br /> selecting more options below
            </p>
            <div className="cbt__end d-flex align-items-center gap-3">
              {isClearFilterStatus && (
                <TooltipTextComponent
                  placement={"top"}
                  children={
                    <span
                      className="afUndo cursor-pointer"
                      role="button"
                      onClick={handleResetFilter}
                    >
                      <FaUndo style={{ width: 14, height: 14 }} />
                    </span>
                  }
                  tooltip_children={"Clear all filters"}
                />
              )}

              {/*Clean single-click expand/collapse toggle */}
              <TooltipTextComponent
                placement={"top"}
                children={
                  <span
                    className={`afCE ${
                      allExpand ? "active" : ""
                    } cursor-pointer`}
                    role="button"
                    onClick={handleExpandCollapse}
                  >
                    <FaCESvgIcn />
                  </span>
                }
                tooltip_children={allExpand ? "Collapse All" : "Expand All"}
              />
            </div>

            {domain === DOMAIN_MTC ? (
              <button
                type="button"
                className="btn-close d-block d-lg-none"
                aria-label="Close"
                title="Close"
                onClick={() => {
                  document.documentElement.classList.remove("filter_overlap");
                  setIsMobileView(false);
                }}
              ></button>
            ) : (
              ""
            )}
          </div>

          <div className="cb__body">
            {showFieldLeft &&
              showFieldLeft.map((fieldItem, i) => {
                let count_data = filterData?.[fieldItem.name]?.length
                  ? filterData?.[fieldItem.name]?.length
                  : 0;
                return (
                  // key forces AccordionComponents to remount on expand/collapse toggle
                  <AccordionComponents
                    key={`${fieldItem.name}-${allExpand}`}
                    defaultActiveKey={fieldItem.active}
                    itemsTitle={[
                      {
                        title: (
                          <>
                            <span className="mb-0 me-1 fw-bold">
                              {fieldItem.title}
                            </span>
                            {/* <span className="mb-0 fw-normal opacity-50">
                            ({count_data})
                          </span> */}
                          </>
                        ),
                        Children: (
                          <>
                            <div className="acco__search mb-2">
                              <TextBoxComponent
                                className="rounded-pill"
                                name={[fieldItem.name]}
                                onChange={filterSearch}
                                placeholder={`Search ${[fieldItem.title]}`}
                              />
                            </div>

                            {count_data ? (
                              <>
                                <div className="acco__list">
                                  {filterData?.[fieldItem.name]?.map(
                                    (items, index) => (
                                      <React.Fragment key={index}>
                                        <CheckBoxComponent
                                          name={[fieldItem.name]}
                                          value={items.value}
                                          checked={formData?.[
                                            fieldItem.name
                                          ]?.includes(items.value)}
                                          label={items.label}
                                          onChange={handleCheckBox}
                                        />
                                        {fieldItem.name === "county" &&
                                        formData?.[fieldItem.name]?.includes(
                                          items.value,
                                        ) &&
                                        localAuthorityOption?.[items.value]
                                          ?.length ? (
                                          <div className="ms-3 mb-2">
                                            <small className="mb-1 d-block ps-3">
                                              <FaArrowDown className="opacity-25 me-2 ps-1" />
                                              Local Authority
                                            </small>
                                            <div className="acco__list">
                                              {localAuthorityOption?.[
                                                items.value
                                              ]?.map((laItems, laIndex) => (
                                                <CheckBoxComponent
                                                  key={laIndex}
                                                  name={"local_authority"}
                                                  value={laItems.value}
                                                  checked={formData?.local_authority?.includes(
                                                    laItems.value,
                                                  )}
                                                  label={laItems.label}
                                                  onChange={handleCheckBox}
                                                />
                                              ))}
                                            </div>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </React.Fragment>
                                    ),
                                  )}
                                </div>
                                <div className="acco__btn">
                                  <ButtonComponent
                                    variant="link"
                                    disabled={
                                      formData?.[fieldItem.name]?.length
                                        ? false
                                        : true
                                    }
                                    onClick={() => {
                                      clearAllFilter([fieldItem.name]);
                                    }}
                                    className="org__pop p-0 border-0"
                                    title="Clear All"
                                  >
                                    Clear All
                                  </ButtonComponent>
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                          </>
                        ),
                      },
                    ]}
                    isFilter={formData?.[fieldItem.name]?.length ? true : false}
                  />
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};

LeftSideFilterComponent.propTypes = {
  history: propTypes.object,
};

export default LeftSideFilterComponent;
